import { render, staticRenderFns } from "./leaderboardBannerTab.vue?vue&type=template&id=02023440&scoped=true&lang=pug"
import script from "./leaderboardBannerTab.vue?vue&type=script&lang=js"
export * from "./leaderboardBannerTab.vue?vue&type=script&lang=js"
import style0 from "./leaderboardBannerTab.vue?vue&type=style&index=0&id=02023440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02023440",
  null
  
)

export default component.exports